
export default function Block({ type, data }) {
  switch (type) {
    case 'header':
      const Element = 'h' + data.level;
      return <Element>{data.text}</Element>;
    case 'paragraph':
      return <p style={{ textAlign: `${data.align}`, marginBottom: `${data.marginBottom}` }}>{data.text}</p>;
    default:
    console.log('Unknown block type', type);
      return null;
  }
}
